export const dashboardData = {
  overview: {
    totalAgents: 87,
    activeAgents: 34,
    totalTokens: 15847392,
    avgResponseTime: 5.2,
    uptime: 99.97,
    dailyRequests: 2847
  },
  realtimeStats: [
    { label: "Requests/hour", value: 124, trend: "+8%", color: "#10b981" },
    { label: "Active Agents", value: 34, trend: "+2%", color: "#8b5cf6" },
    { label: "Avg Response", value: "5.2s", trend: "-0.3s", color: "#06b6d4" },
    { label: "Token Usage", value: "1.2M", trend: "+15%", color: "#f59e0b" }
  ],
  topAgents: [
    { name: "Customer Support Agent", requests: 456, usage: 87, status: "active" },
    { name: "Data Analysis Agent", requests: 234, usage: 65, status: "active" },
    { name: "Content Moderation", requests: 189, usage: 58, status: "active" },
    { name: "Supply Chain Optimizer", requests: 134, usage: 42, status: "active" },
    { name: "Financial Risk Assessor", requests: 89, usage: 35, status: "maintenance" }
  ],
  usageByCategory: [
    { category: "Service", percentage: 35, requests: 996 },
    { category: "Analytics", percentage: 28, requests: 797 },
    { category: "Security", percentage: 18, requests: 512 },
    { category: "Operations", percentage: 12, requests: 341 },
    { category: "Others", percentage: 7, requests: 199 }
  ],
  alerts: [
    { type: "warning", message: "Customer Support Agent experiencing higher than usual response time (7.2s)", time: "5 min ago" },
    { type: "info", message: "Data Analysis Agent updated with improved token efficiency", time: "2 hours ago" },
    { type: "success", message: "System uptime: 30 days without incidents", time: "1 day ago" }
  ]
};